import React from 'react';
import { Outlet } from 'react-router-dom';
import { adminContext } from '../../../context/admincontext';
import { useState } from 'react';
import "../style.css"
const AdminPanel = () => {
    const [toggel, setToggel] = useState(true);
    const [page,setPage] = useState('کارشناس ها')

    return (
        <adminContext.Provider
        value={{
            toggel,
            setToggel,
             page,
             setPage,
          }}
        >
        <div className='w-100'>
        <Outlet />
        </div>
        </adminContext.Provider>
    );
};

export default AdminPanel;